/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProLoginRouteImport } from './routes/pro/login'
import { Route as ProDashboardRouteImport } from './routes/pro/dashboard'
import { Route as ProAcceptInviteRouteImport } from './routes/pro/accept-invite'
import { Route as PetsoLoginRouteImport } from './routes/petso/login'
import { Route as PetsoDashboardRouteImport } from './routes/petso/dashboard'
import { Route as FarmsoLoginRouteImport } from './routes/farmso/login'
import { Route as FarmsoDashboardRouteImport } from './routes/farmso/dashboard'
import { Route as ProDashboardIndexRouteImport } from './routes/pro/dashboard/index'
import { Route as PetsoDashboardIndexRouteImport } from './routes/petso/dashboard/index'
import { Route as FarmsoDashboardIndexRouteImport } from './routes/farmso/dashboard/index'
import { Route as ProDashboardTeamChatRouteImport } from './routes/pro/dashboard/team-chat'
import { Route as ProDashboardTeamRouteImport } from './routes/pro/dashboard/team'
import { Route as ProDashboardStaffScheduleRouteImport } from './routes/pro/dashboard/staff-schedule'
import { Route as ProDashboardSocialsRouteImport } from './routes/pro/dashboard/socials'
import { Route as ProDashboardSettingsRouteImport } from './routes/pro/dashboard/settings'
import { Route as ProDashboardServicesRouteImport } from './routes/pro/dashboard/services'
import { Route as ProDashboardSecurityRouteImport } from './routes/pro/dashboard/security'
import { Route as ProDashboardRolesRouteImport } from './routes/pro/dashboard/roles'
import { Route as ProDashboardRewardsRouteImport } from './routes/pro/dashboard/rewards'
import { Route as ProDashboardReviewsRouteImport } from './routes/pro/dashboard/reviews'
import { Route as ProDashboardReportsRouteImport } from './routes/pro/dashboard/reports'
import { Route as ProDashboardRecurringBookingsRouteImport } from './routes/pro/dashboard/recurring-bookings'
import { Route as ProDashboardPaymentsRouteImport } from './routes/pro/dashboard/payments'
import { Route as ProDashboardPatientsRouteImport } from './routes/pro/dashboard/patients'
import { Route as ProDashboardInvoicesRouteImport } from './routes/pro/dashboard/invoices'
import { Route as ProDashboardCertificatesRouteImport } from './routes/pro/dashboard/certificates'
import { Route as ProDashboardCalendarRouteImport } from './routes/pro/dashboard/calendar'
import { Route as ProDashboardBookingQueueRouteImport } from './routes/pro/dashboard/booking-queue'
import { Route as ProDashboardAuditLogsRouteImport } from './routes/pro/dashboard/audit-logs'
import { Route as ProDashboardAppointmentsRouteImport } from './routes/pro/dashboard/appointments'
import { Route as PetsoDashboardSocialRouteImport } from './routes/petso/dashboard/social'
import { Route as PetsoDashboardSettingsRouteImport } from './routes/petso/dashboard/settings'
import { Route as PetsoDashboardRewardsRouteImport } from './routes/petso/dashboard/rewards'
import { Route as PetsoDashboardNotificationsRouteImport } from './routes/petso/dashboard/notifications'
import { Route as PetsoDashboardFamilyRouteImport } from './routes/petso/dashboard/family'
import { Route as PetsoDashboardEpassportRouteImport } from './routes/petso/dashboard/epassport'
import { Route as PetsoDashboardDocumentsRouteImport } from './routes/petso/dashboard/documents'
import { Route as PetsoDashboardCalendarRouteImport } from './routes/petso/dashboard/calendar'
import { Route as PetsoDashboardBookingRouteImport } from './routes/petso/dashboard/booking'
import { Route as PetsoDashboardAppointmentsRouteImport } from './routes/petso/dashboard/appointments'
import { Route as FarmsoDashboardSupplyRouteImport } from './routes/farmso/dashboard/supply'
import { Route as FarmsoDashboardSettingsRouteImport } from './routes/farmso/dashboard/settings'
import { Route as FarmsoDashboardSalesRouteImport } from './routes/farmso/dashboard/sales'
import { Route as FarmsoDashboardLivestockRouteImport } from './routes/farmso/dashboard/livestock'
import { Route as FarmsoDashboardComplianceRouteImport } from './routes/farmso/dashboard/compliance'
import { Route as FarmsoDashboardAppointmentsRouteImport } from './routes/farmso/dashboard/appointments'
import { Route as FarmsoDashboardAnalyticsRouteImport } from './routes/farmso/dashboard/analytics'
import { Route as ProDashboardMemberMemberIdRouteImport } from './routes/pro/dashboard/member.$memberId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProLoginRoute = ProLoginRouteImport.update({
  id: '/pro/login',
  path: '/pro/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProDashboardRoute = ProDashboardRouteImport.update({
  id: '/pro/dashboard',
  path: '/pro/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ProAcceptInviteRoute = ProAcceptInviteRouteImport.update({
  id: '/pro/accept-invite',
  path: '/pro/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const PetsoLoginRoute = PetsoLoginRouteImport.update({
  id: '/petso/login',
  path: '/petso/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PetsoDashboardRoute = PetsoDashboardRouteImport.update({
  id: '/petso/dashboard',
  path: '/petso/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FarmsoLoginRoute = FarmsoLoginRouteImport.update({
  id: '/farmso/login',
  path: '/farmso/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FarmsoDashboardRoute = FarmsoDashboardRouteImport.update({
  id: '/farmso/dashboard',
  path: '/farmso/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ProDashboardIndexRoute = ProDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProDashboardRoute,
} as any)
const PetsoDashboardIndexRoute = PetsoDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const FarmsoDashboardIndexRoute = FarmsoDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FarmsoDashboardRoute,
} as any)
const ProDashboardTeamChatRoute = ProDashboardTeamChatRouteImport.update({
  id: '/team-chat',
  path: '/team-chat',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardTeamRoute = ProDashboardTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardStaffScheduleRoute =
  ProDashboardStaffScheduleRouteImport.update({
    id: '/staff-schedule',
    path: '/staff-schedule',
    getParentRoute: () => ProDashboardRoute,
  } as any)
const ProDashboardSocialsRoute = ProDashboardSocialsRouteImport.update({
  id: '/socials',
  path: '/socials',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardSettingsRoute = ProDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardServicesRoute = ProDashboardServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardSecurityRoute = ProDashboardSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardRolesRoute = ProDashboardRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardRewardsRoute = ProDashboardRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardReviewsRoute = ProDashboardReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardReportsRoute = ProDashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardRecurringBookingsRoute =
  ProDashboardRecurringBookingsRouteImport.update({
    id: '/recurring-bookings',
    path: '/recurring-bookings',
    getParentRoute: () => ProDashboardRoute,
  } as any)
const ProDashboardPaymentsRoute = ProDashboardPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardPatientsRoute = ProDashboardPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardInvoicesRoute = ProDashboardInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardCertificatesRoute =
  ProDashboardCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => ProDashboardRoute,
  } as any)
const ProDashboardCalendarRoute = ProDashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardBookingQueueRoute =
  ProDashboardBookingQueueRouteImport.update({
    id: '/booking-queue',
    path: '/booking-queue',
    getParentRoute: () => ProDashboardRoute,
  } as any)
const ProDashboardAuditLogsRoute = ProDashboardAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => ProDashboardRoute,
} as any)
const ProDashboardAppointmentsRoute =
  ProDashboardAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => ProDashboardRoute,
  } as any)
const PetsoDashboardSocialRoute = PetsoDashboardSocialRouteImport.update({
  id: '/social',
  path: '/social',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardSettingsRoute = PetsoDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardRewardsRoute = PetsoDashboardRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardNotificationsRoute =
  PetsoDashboardNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => PetsoDashboardRoute,
  } as any)
const PetsoDashboardFamilyRoute = PetsoDashboardFamilyRouteImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardEpassportRoute = PetsoDashboardEpassportRouteImport.update({
  id: '/epassport',
  path: '/epassport',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardDocumentsRoute = PetsoDashboardDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardCalendarRoute = PetsoDashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardBookingRoute = PetsoDashboardBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => PetsoDashboardRoute,
} as any)
const PetsoDashboardAppointmentsRoute =
  PetsoDashboardAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => PetsoDashboardRoute,
  } as any)
const FarmsoDashboardSupplyRoute = FarmsoDashboardSupplyRouteImport.update({
  id: '/supply',
  path: '/supply',
  getParentRoute: () => FarmsoDashboardRoute,
} as any)
const FarmsoDashboardSettingsRoute = FarmsoDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => FarmsoDashboardRoute,
} as any)
const FarmsoDashboardSalesRoute = FarmsoDashboardSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => FarmsoDashboardRoute,
} as any)
const FarmsoDashboardLivestockRoute =
  FarmsoDashboardLivestockRouteImport.update({
    id: '/livestock',
    path: '/livestock',
    getParentRoute: () => FarmsoDashboardRoute,
  } as any)
const FarmsoDashboardComplianceRoute =
  FarmsoDashboardComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => FarmsoDashboardRoute,
  } as any)
const FarmsoDashboardAppointmentsRoute =
  FarmsoDashboardAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => FarmsoDashboardRoute,
  } as any)
const FarmsoDashboardAnalyticsRoute =
  FarmsoDashboardAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => FarmsoDashboardRoute,
  } as any)
const ProDashboardMemberMemberIdRoute =
  ProDashboardMemberMemberIdRouteImport.update({
    id: '/member/$memberId',
    path: '/member/$memberId',
    getParentRoute: () => ProDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/farmso/dashboard': typeof FarmsoDashboardRouteWithChildren
  '/farmso/login': typeof FarmsoLoginRoute
  '/petso/dashboard': typeof PetsoDashboardRouteWithChildren
  '/petso/login': typeof PetsoLoginRoute
  '/pro/accept-invite': typeof ProAcceptInviteRoute
  '/pro/dashboard': typeof ProDashboardRouteWithChildren
  '/pro/login': typeof ProLoginRoute
  '/farmso/dashboard/analytics': typeof FarmsoDashboardAnalyticsRoute
  '/farmso/dashboard/appointments': typeof FarmsoDashboardAppointmentsRoute
  '/farmso/dashboard/compliance': typeof FarmsoDashboardComplianceRoute
  '/farmso/dashboard/livestock': typeof FarmsoDashboardLivestockRoute
  '/farmso/dashboard/sales': typeof FarmsoDashboardSalesRoute
  '/farmso/dashboard/settings': typeof FarmsoDashboardSettingsRoute
  '/farmso/dashboard/supply': typeof FarmsoDashboardSupplyRoute
  '/petso/dashboard/appointments': typeof PetsoDashboardAppointmentsRoute
  '/petso/dashboard/booking': typeof PetsoDashboardBookingRoute
  '/petso/dashboard/calendar': typeof PetsoDashboardCalendarRoute
  '/petso/dashboard/documents': typeof PetsoDashboardDocumentsRoute
  '/petso/dashboard/epassport': typeof PetsoDashboardEpassportRoute
  '/petso/dashboard/family': typeof PetsoDashboardFamilyRoute
  '/petso/dashboard/notifications': typeof PetsoDashboardNotificationsRoute
  '/petso/dashboard/rewards': typeof PetsoDashboardRewardsRoute
  '/petso/dashboard/settings': typeof PetsoDashboardSettingsRoute
  '/petso/dashboard/social': typeof PetsoDashboardSocialRoute
  '/pro/dashboard/appointments': typeof ProDashboardAppointmentsRoute
  '/pro/dashboard/audit-logs': typeof ProDashboardAuditLogsRoute
  '/pro/dashboard/booking-queue': typeof ProDashboardBookingQueueRoute
  '/pro/dashboard/calendar': typeof ProDashboardCalendarRoute
  '/pro/dashboard/certificates': typeof ProDashboardCertificatesRoute
  '/pro/dashboard/invoices': typeof ProDashboardInvoicesRoute
  '/pro/dashboard/patients': typeof ProDashboardPatientsRoute
  '/pro/dashboard/payments': typeof ProDashboardPaymentsRoute
  '/pro/dashboard/recurring-bookings': typeof ProDashboardRecurringBookingsRoute
  '/pro/dashboard/reports': typeof ProDashboardReportsRoute
  '/pro/dashboard/reviews': typeof ProDashboardReviewsRoute
  '/pro/dashboard/rewards': typeof ProDashboardRewardsRoute
  '/pro/dashboard/roles': typeof ProDashboardRolesRoute
  '/pro/dashboard/security': typeof ProDashboardSecurityRoute
  '/pro/dashboard/services': typeof ProDashboardServicesRoute
  '/pro/dashboard/settings': typeof ProDashboardSettingsRoute
  '/pro/dashboard/socials': typeof ProDashboardSocialsRoute
  '/pro/dashboard/staff-schedule': typeof ProDashboardStaffScheduleRoute
  '/pro/dashboard/team': typeof ProDashboardTeamRoute
  '/pro/dashboard/team-chat': typeof ProDashboardTeamChatRoute
  '/farmso/dashboard/': typeof FarmsoDashboardIndexRoute
  '/petso/dashboard/': typeof PetsoDashboardIndexRoute
  '/pro/dashboard/': typeof ProDashboardIndexRoute
  '/pro/dashboard/member/$memberId': typeof ProDashboardMemberMemberIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/farmso/login': typeof FarmsoLoginRoute
  '/petso/login': typeof PetsoLoginRoute
  '/pro/accept-invite': typeof ProAcceptInviteRoute
  '/pro/login': typeof ProLoginRoute
  '/farmso/dashboard/analytics': typeof FarmsoDashboardAnalyticsRoute
  '/farmso/dashboard/appointments': typeof FarmsoDashboardAppointmentsRoute
  '/farmso/dashboard/compliance': typeof FarmsoDashboardComplianceRoute
  '/farmso/dashboard/livestock': typeof FarmsoDashboardLivestockRoute
  '/farmso/dashboard/sales': typeof FarmsoDashboardSalesRoute
  '/farmso/dashboard/settings': typeof FarmsoDashboardSettingsRoute
  '/farmso/dashboard/supply': typeof FarmsoDashboardSupplyRoute
  '/petso/dashboard/appointments': typeof PetsoDashboardAppointmentsRoute
  '/petso/dashboard/booking': typeof PetsoDashboardBookingRoute
  '/petso/dashboard/calendar': typeof PetsoDashboardCalendarRoute
  '/petso/dashboard/documents': typeof PetsoDashboardDocumentsRoute
  '/petso/dashboard/epassport': typeof PetsoDashboardEpassportRoute
  '/petso/dashboard/family': typeof PetsoDashboardFamilyRoute
  '/petso/dashboard/notifications': typeof PetsoDashboardNotificationsRoute
  '/petso/dashboard/rewards': typeof PetsoDashboardRewardsRoute
  '/petso/dashboard/settings': typeof PetsoDashboardSettingsRoute
  '/petso/dashboard/social': typeof PetsoDashboardSocialRoute
  '/pro/dashboard/appointments': typeof ProDashboardAppointmentsRoute
  '/pro/dashboard/audit-logs': typeof ProDashboardAuditLogsRoute
  '/pro/dashboard/booking-queue': typeof ProDashboardBookingQueueRoute
  '/pro/dashboard/calendar': typeof ProDashboardCalendarRoute
  '/pro/dashboard/certificates': typeof ProDashboardCertificatesRoute
  '/pro/dashboard/invoices': typeof ProDashboardInvoicesRoute
  '/pro/dashboard/patients': typeof ProDashboardPatientsRoute
  '/pro/dashboard/payments': typeof ProDashboardPaymentsRoute
  '/pro/dashboard/recurring-bookings': typeof ProDashboardRecurringBookingsRoute
  '/pro/dashboard/reports': typeof ProDashboardReportsRoute
  '/pro/dashboard/reviews': typeof ProDashboardReviewsRoute
  '/pro/dashboard/rewards': typeof ProDashboardRewardsRoute
  '/pro/dashboard/roles': typeof ProDashboardRolesRoute
  '/pro/dashboard/security': typeof ProDashboardSecurityRoute
  '/pro/dashboard/services': typeof ProDashboardServicesRoute
  '/pro/dashboard/settings': typeof ProDashboardSettingsRoute
  '/pro/dashboard/socials': typeof ProDashboardSocialsRoute
  '/pro/dashboard/staff-schedule': typeof ProDashboardStaffScheduleRoute
  '/pro/dashboard/team': typeof ProDashboardTeamRoute
  '/pro/dashboard/team-chat': typeof ProDashboardTeamChatRoute
  '/farmso/dashboard': typeof FarmsoDashboardIndexRoute
  '/petso/dashboard': typeof PetsoDashboardIndexRoute
  '/pro/dashboard': typeof ProDashboardIndexRoute
  '/pro/dashboard/member/$memberId': typeof ProDashboardMemberMemberIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/farmso/dashboard': typeof FarmsoDashboardRouteWithChildren
  '/farmso/login': typeof FarmsoLoginRoute
  '/petso/dashboard': typeof PetsoDashboardRouteWithChildren
  '/petso/login': typeof PetsoLoginRoute
  '/pro/accept-invite': typeof ProAcceptInviteRoute
  '/pro/dashboard': typeof ProDashboardRouteWithChildren
  '/pro/login': typeof ProLoginRoute
  '/farmso/dashboard/analytics': typeof FarmsoDashboardAnalyticsRoute
  '/farmso/dashboard/appointments': typeof FarmsoDashboardAppointmentsRoute
  '/farmso/dashboard/compliance': typeof FarmsoDashboardComplianceRoute
  '/farmso/dashboard/livestock': typeof FarmsoDashboardLivestockRoute
  '/farmso/dashboard/sales': typeof FarmsoDashboardSalesRoute
  '/farmso/dashboard/settings': typeof FarmsoDashboardSettingsRoute
  '/farmso/dashboard/supply': typeof FarmsoDashboardSupplyRoute
  '/petso/dashboard/appointments': typeof PetsoDashboardAppointmentsRoute
  '/petso/dashboard/booking': typeof PetsoDashboardBookingRoute
  '/petso/dashboard/calendar': typeof PetsoDashboardCalendarRoute
  '/petso/dashboard/documents': typeof PetsoDashboardDocumentsRoute
  '/petso/dashboard/epassport': typeof PetsoDashboardEpassportRoute
  '/petso/dashboard/family': typeof PetsoDashboardFamilyRoute
  '/petso/dashboard/notifications': typeof PetsoDashboardNotificationsRoute
  '/petso/dashboard/rewards': typeof PetsoDashboardRewardsRoute
  '/petso/dashboard/settings': typeof PetsoDashboardSettingsRoute
  '/petso/dashboard/social': typeof PetsoDashboardSocialRoute
  '/pro/dashboard/appointments': typeof ProDashboardAppointmentsRoute
  '/pro/dashboard/audit-logs': typeof ProDashboardAuditLogsRoute
  '/pro/dashboard/booking-queue': typeof ProDashboardBookingQueueRoute
  '/pro/dashboard/calendar': typeof ProDashboardCalendarRoute
  '/pro/dashboard/certificates': typeof ProDashboardCertificatesRoute
  '/pro/dashboard/invoices': typeof ProDashboardInvoicesRoute
  '/pro/dashboard/patients': typeof ProDashboardPatientsRoute
  '/pro/dashboard/payments': typeof ProDashboardPaymentsRoute
  '/pro/dashboard/recurring-bookings': typeof ProDashboardRecurringBookingsRoute
  '/pro/dashboard/reports': typeof ProDashboardReportsRoute
  '/pro/dashboard/reviews': typeof ProDashboardReviewsRoute
  '/pro/dashboard/rewards': typeof ProDashboardRewardsRoute
  '/pro/dashboard/roles': typeof ProDashboardRolesRoute
  '/pro/dashboard/security': typeof ProDashboardSecurityRoute
  '/pro/dashboard/services': typeof ProDashboardServicesRoute
  '/pro/dashboard/settings': typeof ProDashboardSettingsRoute
  '/pro/dashboard/socials': typeof ProDashboardSocialsRoute
  '/pro/dashboard/staff-schedule': typeof ProDashboardStaffScheduleRoute
  '/pro/dashboard/team': typeof ProDashboardTeamRoute
  '/pro/dashboard/team-chat': typeof ProDashboardTeamChatRoute
  '/farmso/dashboard/': typeof FarmsoDashboardIndexRoute
  '/petso/dashboard/': typeof PetsoDashboardIndexRoute
  '/pro/dashboard/': typeof ProDashboardIndexRoute
  '/pro/dashboard/member/$memberId': typeof ProDashboardMemberMemberIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/farmso/dashboard'
    | '/farmso/login'
    | '/petso/dashboard'
    | '/petso/login'
    | '/pro/accept-invite'
    | '/pro/dashboard'
    | '/pro/login'
    | '/farmso/dashboard/analytics'
    | '/farmso/dashboard/appointments'
    | '/farmso/dashboard/compliance'
    | '/farmso/dashboard/livestock'
    | '/farmso/dashboard/sales'
    | '/farmso/dashboard/settings'
    | '/farmso/dashboard/supply'
    | '/petso/dashboard/appointments'
    | '/petso/dashboard/booking'
    | '/petso/dashboard/calendar'
    | '/petso/dashboard/documents'
    | '/petso/dashboard/epassport'
    | '/petso/dashboard/family'
    | '/petso/dashboard/notifications'
    | '/petso/dashboard/rewards'
    | '/petso/dashboard/settings'
    | '/petso/dashboard/social'
    | '/pro/dashboard/appointments'
    | '/pro/dashboard/audit-logs'
    | '/pro/dashboard/booking-queue'
    | '/pro/dashboard/calendar'
    | '/pro/dashboard/certificates'
    | '/pro/dashboard/invoices'
    | '/pro/dashboard/patients'
    | '/pro/dashboard/payments'
    | '/pro/dashboard/recurring-bookings'
    | '/pro/dashboard/reports'
    | '/pro/dashboard/reviews'
    | '/pro/dashboard/rewards'
    | '/pro/dashboard/roles'
    | '/pro/dashboard/security'
    | '/pro/dashboard/services'
    | '/pro/dashboard/settings'
    | '/pro/dashboard/socials'
    | '/pro/dashboard/staff-schedule'
    | '/pro/dashboard/team'
    | '/pro/dashboard/team-chat'
    | '/farmso/dashboard/'
    | '/petso/dashboard/'
    | '/pro/dashboard/'
    | '/pro/dashboard/member/$memberId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/farmso/login'
    | '/petso/login'
    | '/pro/accept-invite'
    | '/pro/login'
    | '/farmso/dashboard/analytics'
    | '/farmso/dashboard/appointments'
    | '/farmso/dashboard/compliance'
    | '/farmso/dashboard/livestock'
    | '/farmso/dashboard/sales'
    | '/farmso/dashboard/settings'
    | '/farmso/dashboard/supply'
    | '/petso/dashboard/appointments'
    | '/petso/dashboard/booking'
    | '/petso/dashboard/calendar'
    | '/petso/dashboard/documents'
    | '/petso/dashboard/epassport'
    | '/petso/dashboard/family'
    | '/petso/dashboard/notifications'
    | '/petso/dashboard/rewards'
    | '/petso/dashboard/settings'
    | '/petso/dashboard/social'
    | '/pro/dashboard/appointments'
    | '/pro/dashboard/audit-logs'
    | '/pro/dashboard/booking-queue'
    | '/pro/dashboard/calendar'
    | '/pro/dashboard/certificates'
    | '/pro/dashboard/invoices'
    | '/pro/dashboard/patients'
    | '/pro/dashboard/payments'
    | '/pro/dashboard/recurring-bookings'
    | '/pro/dashboard/reports'
    | '/pro/dashboard/reviews'
    | '/pro/dashboard/rewards'
    | '/pro/dashboard/roles'
    | '/pro/dashboard/security'
    | '/pro/dashboard/services'
    | '/pro/dashboard/settings'
    | '/pro/dashboard/socials'
    | '/pro/dashboard/staff-schedule'
    | '/pro/dashboard/team'
    | '/pro/dashboard/team-chat'
    | '/farmso/dashboard'
    | '/petso/dashboard'
    | '/pro/dashboard'
    | '/pro/dashboard/member/$memberId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/farmso/dashboard'
    | '/farmso/login'
    | '/petso/dashboard'
    | '/petso/login'
    | '/pro/accept-invite'
    | '/pro/dashboard'
    | '/pro/login'
    | '/farmso/dashboard/analytics'
    | '/farmso/dashboard/appointments'
    | '/farmso/dashboard/compliance'
    | '/farmso/dashboard/livestock'
    | '/farmso/dashboard/sales'
    | '/farmso/dashboard/settings'
    | '/farmso/dashboard/supply'
    | '/petso/dashboard/appointments'
    | '/petso/dashboard/booking'
    | '/petso/dashboard/calendar'
    | '/petso/dashboard/documents'
    | '/petso/dashboard/epassport'
    | '/petso/dashboard/family'
    | '/petso/dashboard/notifications'
    | '/petso/dashboard/rewards'
    | '/petso/dashboard/settings'
    | '/petso/dashboard/social'
    | '/pro/dashboard/appointments'
    | '/pro/dashboard/audit-logs'
    | '/pro/dashboard/booking-queue'
    | '/pro/dashboard/calendar'
    | '/pro/dashboard/certificates'
    | '/pro/dashboard/invoices'
    | '/pro/dashboard/patients'
    | '/pro/dashboard/payments'
    | '/pro/dashboard/recurring-bookings'
    | '/pro/dashboard/reports'
    | '/pro/dashboard/reviews'
    | '/pro/dashboard/rewards'
    | '/pro/dashboard/roles'
    | '/pro/dashboard/security'
    | '/pro/dashboard/services'
    | '/pro/dashboard/settings'
    | '/pro/dashboard/socials'
    | '/pro/dashboard/staff-schedule'
    | '/pro/dashboard/team'
    | '/pro/dashboard/team-chat'
    | '/farmso/dashboard/'
    | '/petso/dashboard/'
    | '/pro/dashboard/'
    | '/pro/dashboard/member/$memberId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  FarmsoDashboardRoute: typeof FarmsoDashboardRouteWithChildren
  FarmsoLoginRoute: typeof FarmsoLoginRoute
  PetsoDashboardRoute: typeof PetsoDashboardRouteWithChildren
  PetsoLoginRoute: typeof PetsoLoginRoute
  ProAcceptInviteRoute: typeof ProAcceptInviteRoute
  ProDashboardRoute: typeof ProDashboardRouteWithChildren
  ProLoginRoute: typeof ProLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/login': {
      id: '/pro/login'
      path: '/pro/login'
      fullPath: '/pro/login'
      preLoaderRoute: typeof ProLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/dashboard': {
      id: '/pro/dashboard'
      path: '/pro/dashboard'
      fullPath: '/pro/dashboard'
      preLoaderRoute: typeof ProDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/accept-invite': {
      id: '/pro/accept-invite'
      path: '/pro/accept-invite'
      fullPath: '/pro/accept-invite'
      preLoaderRoute: typeof ProAcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/petso/login': {
      id: '/petso/login'
      path: '/petso/login'
      fullPath: '/petso/login'
      preLoaderRoute: typeof PetsoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/petso/dashboard': {
      id: '/petso/dashboard'
      path: '/petso/dashboard'
      fullPath: '/petso/dashboard'
      preLoaderRoute: typeof PetsoDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farmso/login': {
      id: '/farmso/login'
      path: '/farmso/login'
      fullPath: '/farmso/login'
      preLoaderRoute: typeof FarmsoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farmso/dashboard': {
      id: '/farmso/dashboard'
      path: '/farmso/dashboard'
      fullPath: '/farmso/dashboard'
      preLoaderRoute: typeof FarmsoDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/dashboard/': {
      id: '/pro/dashboard/'
      path: '/'
      fullPath: '/pro/dashboard/'
      preLoaderRoute: typeof ProDashboardIndexRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/petso/dashboard/': {
      id: '/petso/dashboard/'
      path: '/'
      fullPath: '/petso/dashboard/'
      preLoaderRoute: typeof PetsoDashboardIndexRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/farmso/dashboard/': {
      id: '/farmso/dashboard/'
      path: '/'
      fullPath: '/farmso/dashboard/'
      preLoaderRoute: typeof FarmsoDashboardIndexRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/pro/dashboard/team-chat': {
      id: '/pro/dashboard/team-chat'
      path: '/team-chat'
      fullPath: '/pro/dashboard/team-chat'
      preLoaderRoute: typeof ProDashboardTeamChatRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/team': {
      id: '/pro/dashboard/team'
      path: '/team'
      fullPath: '/pro/dashboard/team'
      preLoaderRoute: typeof ProDashboardTeamRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/staff-schedule': {
      id: '/pro/dashboard/staff-schedule'
      path: '/staff-schedule'
      fullPath: '/pro/dashboard/staff-schedule'
      preLoaderRoute: typeof ProDashboardStaffScheduleRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/socials': {
      id: '/pro/dashboard/socials'
      path: '/socials'
      fullPath: '/pro/dashboard/socials'
      preLoaderRoute: typeof ProDashboardSocialsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/settings': {
      id: '/pro/dashboard/settings'
      path: '/settings'
      fullPath: '/pro/dashboard/settings'
      preLoaderRoute: typeof ProDashboardSettingsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/services': {
      id: '/pro/dashboard/services'
      path: '/services'
      fullPath: '/pro/dashboard/services'
      preLoaderRoute: typeof ProDashboardServicesRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/security': {
      id: '/pro/dashboard/security'
      path: '/security'
      fullPath: '/pro/dashboard/security'
      preLoaderRoute: typeof ProDashboardSecurityRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/roles': {
      id: '/pro/dashboard/roles'
      path: '/roles'
      fullPath: '/pro/dashboard/roles'
      preLoaderRoute: typeof ProDashboardRolesRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/rewards': {
      id: '/pro/dashboard/rewards'
      path: '/rewards'
      fullPath: '/pro/dashboard/rewards'
      preLoaderRoute: typeof ProDashboardRewardsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/reviews': {
      id: '/pro/dashboard/reviews'
      path: '/reviews'
      fullPath: '/pro/dashboard/reviews'
      preLoaderRoute: typeof ProDashboardReviewsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/reports': {
      id: '/pro/dashboard/reports'
      path: '/reports'
      fullPath: '/pro/dashboard/reports'
      preLoaderRoute: typeof ProDashboardReportsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/recurring-bookings': {
      id: '/pro/dashboard/recurring-bookings'
      path: '/recurring-bookings'
      fullPath: '/pro/dashboard/recurring-bookings'
      preLoaderRoute: typeof ProDashboardRecurringBookingsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/payments': {
      id: '/pro/dashboard/payments'
      path: '/payments'
      fullPath: '/pro/dashboard/payments'
      preLoaderRoute: typeof ProDashboardPaymentsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/patients': {
      id: '/pro/dashboard/patients'
      path: '/patients'
      fullPath: '/pro/dashboard/patients'
      preLoaderRoute: typeof ProDashboardPatientsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/invoices': {
      id: '/pro/dashboard/invoices'
      path: '/invoices'
      fullPath: '/pro/dashboard/invoices'
      preLoaderRoute: typeof ProDashboardInvoicesRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/certificates': {
      id: '/pro/dashboard/certificates'
      path: '/certificates'
      fullPath: '/pro/dashboard/certificates'
      preLoaderRoute: typeof ProDashboardCertificatesRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/calendar': {
      id: '/pro/dashboard/calendar'
      path: '/calendar'
      fullPath: '/pro/dashboard/calendar'
      preLoaderRoute: typeof ProDashboardCalendarRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/booking-queue': {
      id: '/pro/dashboard/booking-queue'
      path: '/booking-queue'
      fullPath: '/pro/dashboard/booking-queue'
      preLoaderRoute: typeof ProDashboardBookingQueueRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/audit-logs': {
      id: '/pro/dashboard/audit-logs'
      path: '/audit-logs'
      fullPath: '/pro/dashboard/audit-logs'
      preLoaderRoute: typeof ProDashboardAuditLogsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/pro/dashboard/appointments': {
      id: '/pro/dashboard/appointments'
      path: '/appointments'
      fullPath: '/pro/dashboard/appointments'
      preLoaderRoute: typeof ProDashboardAppointmentsRouteImport
      parentRoute: typeof ProDashboardRoute
    }
    '/petso/dashboard/social': {
      id: '/petso/dashboard/social'
      path: '/social'
      fullPath: '/petso/dashboard/social'
      preLoaderRoute: typeof PetsoDashboardSocialRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/settings': {
      id: '/petso/dashboard/settings'
      path: '/settings'
      fullPath: '/petso/dashboard/settings'
      preLoaderRoute: typeof PetsoDashboardSettingsRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/rewards': {
      id: '/petso/dashboard/rewards'
      path: '/rewards'
      fullPath: '/petso/dashboard/rewards'
      preLoaderRoute: typeof PetsoDashboardRewardsRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/notifications': {
      id: '/petso/dashboard/notifications'
      path: '/notifications'
      fullPath: '/petso/dashboard/notifications'
      preLoaderRoute: typeof PetsoDashboardNotificationsRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/family': {
      id: '/petso/dashboard/family'
      path: '/family'
      fullPath: '/petso/dashboard/family'
      preLoaderRoute: typeof PetsoDashboardFamilyRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/epassport': {
      id: '/petso/dashboard/epassport'
      path: '/epassport'
      fullPath: '/petso/dashboard/epassport'
      preLoaderRoute: typeof PetsoDashboardEpassportRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/documents': {
      id: '/petso/dashboard/documents'
      path: '/documents'
      fullPath: '/petso/dashboard/documents'
      preLoaderRoute: typeof PetsoDashboardDocumentsRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/calendar': {
      id: '/petso/dashboard/calendar'
      path: '/calendar'
      fullPath: '/petso/dashboard/calendar'
      preLoaderRoute: typeof PetsoDashboardCalendarRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/booking': {
      id: '/petso/dashboard/booking'
      path: '/booking'
      fullPath: '/petso/dashboard/booking'
      preLoaderRoute: typeof PetsoDashboardBookingRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/petso/dashboard/appointments': {
      id: '/petso/dashboard/appointments'
      path: '/appointments'
      fullPath: '/petso/dashboard/appointments'
      preLoaderRoute: typeof PetsoDashboardAppointmentsRouteImport
      parentRoute: typeof PetsoDashboardRoute
    }
    '/farmso/dashboard/supply': {
      id: '/farmso/dashboard/supply'
      path: '/supply'
      fullPath: '/farmso/dashboard/supply'
      preLoaderRoute: typeof FarmsoDashboardSupplyRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/settings': {
      id: '/farmso/dashboard/settings'
      path: '/settings'
      fullPath: '/farmso/dashboard/settings'
      preLoaderRoute: typeof FarmsoDashboardSettingsRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/sales': {
      id: '/farmso/dashboard/sales'
      path: '/sales'
      fullPath: '/farmso/dashboard/sales'
      preLoaderRoute: typeof FarmsoDashboardSalesRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/livestock': {
      id: '/farmso/dashboard/livestock'
      path: '/livestock'
      fullPath: '/farmso/dashboard/livestock'
      preLoaderRoute: typeof FarmsoDashboardLivestockRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/compliance': {
      id: '/farmso/dashboard/compliance'
      path: '/compliance'
      fullPath: '/farmso/dashboard/compliance'
      preLoaderRoute: typeof FarmsoDashboardComplianceRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/appointments': {
      id: '/farmso/dashboard/appointments'
      path: '/appointments'
      fullPath: '/farmso/dashboard/appointments'
      preLoaderRoute: typeof FarmsoDashboardAppointmentsRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/farmso/dashboard/analytics': {
      id: '/farmso/dashboard/analytics'
      path: '/analytics'
      fullPath: '/farmso/dashboard/analytics'
      preLoaderRoute: typeof FarmsoDashboardAnalyticsRouteImport
      parentRoute: typeof FarmsoDashboardRoute
    }
    '/pro/dashboard/member/$memberId': {
      id: '/pro/dashboard/member/$memberId'
      path: '/member/$memberId'
      fullPath: '/pro/dashboard/member/$memberId'
      preLoaderRoute: typeof ProDashboardMemberMemberIdRouteImport
      parentRoute: typeof ProDashboardRoute
    }
  }
}

interface FarmsoDashboardRouteChildren {
  FarmsoDashboardAnalyticsRoute: typeof FarmsoDashboardAnalyticsRoute
  FarmsoDashboardAppointmentsRoute: typeof FarmsoDashboardAppointmentsRoute
  FarmsoDashboardComplianceRoute: typeof FarmsoDashboardComplianceRoute
  FarmsoDashboardLivestockRoute: typeof FarmsoDashboardLivestockRoute
  FarmsoDashboardSalesRoute: typeof FarmsoDashboardSalesRoute
  FarmsoDashboardSettingsRoute: typeof FarmsoDashboardSettingsRoute
  FarmsoDashboardSupplyRoute: typeof FarmsoDashboardSupplyRoute
  FarmsoDashboardIndexRoute: typeof FarmsoDashboardIndexRoute
}

const FarmsoDashboardRouteChildren: FarmsoDashboardRouteChildren = {
  FarmsoDashboardAnalyticsRoute: FarmsoDashboardAnalyticsRoute,
  FarmsoDashboardAppointmentsRoute: FarmsoDashboardAppointmentsRoute,
  FarmsoDashboardComplianceRoute: FarmsoDashboardComplianceRoute,
  FarmsoDashboardLivestockRoute: FarmsoDashboardLivestockRoute,
  FarmsoDashboardSalesRoute: FarmsoDashboardSalesRoute,
  FarmsoDashboardSettingsRoute: FarmsoDashboardSettingsRoute,
  FarmsoDashboardSupplyRoute: FarmsoDashboardSupplyRoute,
  FarmsoDashboardIndexRoute: FarmsoDashboardIndexRoute,
}

const FarmsoDashboardRouteWithChildren = FarmsoDashboardRoute._addFileChildren(
  FarmsoDashboardRouteChildren,
)

interface PetsoDashboardRouteChildren {
  PetsoDashboardAppointmentsRoute: typeof PetsoDashboardAppointmentsRoute
  PetsoDashboardBookingRoute: typeof PetsoDashboardBookingRoute
  PetsoDashboardCalendarRoute: typeof PetsoDashboardCalendarRoute
  PetsoDashboardDocumentsRoute: typeof PetsoDashboardDocumentsRoute
  PetsoDashboardEpassportRoute: typeof PetsoDashboardEpassportRoute
  PetsoDashboardFamilyRoute: typeof PetsoDashboardFamilyRoute
  PetsoDashboardNotificationsRoute: typeof PetsoDashboardNotificationsRoute
  PetsoDashboardRewardsRoute: typeof PetsoDashboardRewardsRoute
  PetsoDashboardSettingsRoute: typeof PetsoDashboardSettingsRoute
  PetsoDashboardSocialRoute: typeof PetsoDashboardSocialRoute
  PetsoDashboardIndexRoute: typeof PetsoDashboardIndexRoute
}

const PetsoDashboardRouteChildren: PetsoDashboardRouteChildren = {
  PetsoDashboardAppointmentsRoute: PetsoDashboardAppointmentsRoute,
  PetsoDashboardBookingRoute: PetsoDashboardBookingRoute,
  PetsoDashboardCalendarRoute: PetsoDashboardCalendarRoute,
  PetsoDashboardDocumentsRoute: PetsoDashboardDocumentsRoute,
  PetsoDashboardEpassportRoute: PetsoDashboardEpassportRoute,
  PetsoDashboardFamilyRoute: PetsoDashboardFamilyRoute,
  PetsoDashboardNotificationsRoute: PetsoDashboardNotificationsRoute,
  PetsoDashboardRewardsRoute: PetsoDashboardRewardsRoute,
  PetsoDashboardSettingsRoute: PetsoDashboardSettingsRoute,
  PetsoDashboardSocialRoute: PetsoDashboardSocialRoute,
  PetsoDashboardIndexRoute: PetsoDashboardIndexRoute,
}

const PetsoDashboardRouteWithChildren = PetsoDashboardRoute._addFileChildren(
  PetsoDashboardRouteChildren,
)

interface ProDashboardRouteChildren {
  ProDashboardAppointmentsRoute: typeof ProDashboardAppointmentsRoute
  ProDashboardAuditLogsRoute: typeof ProDashboardAuditLogsRoute
  ProDashboardBookingQueueRoute: typeof ProDashboardBookingQueueRoute
  ProDashboardCalendarRoute: typeof ProDashboardCalendarRoute
  ProDashboardCertificatesRoute: typeof ProDashboardCertificatesRoute
  ProDashboardInvoicesRoute: typeof ProDashboardInvoicesRoute
  ProDashboardPatientsRoute: typeof ProDashboardPatientsRoute
  ProDashboardPaymentsRoute: typeof ProDashboardPaymentsRoute
  ProDashboardRecurringBookingsRoute: typeof ProDashboardRecurringBookingsRoute
  ProDashboardReportsRoute: typeof ProDashboardReportsRoute
  ProDashboardReviewsRoute: typeof ProDashboardReviewsRoute
  ProDashboardRewardsRoute: typeof ProDashboardRewardsRoute
  ProDashboardRolesRoute: typeof ProDashboardRolesRoute
  ProDashboardSecurityRoute: typeof ProDashboardSecurityRoute
  ProDashboardServicesRoute: typeof ProDashboardServicesRoute
  ProDashboardSettingsRoute: typeof ProDashboardSettingsRoute
  ProDashboardSocialsRoute: typeof ProDashboardSocialsRoute
  ProDashboardStaffScheduleRoute: typeof ProDashboardStaffScheduleRoute
  ProDashboardTeamRoute: typeof ProDashboardTeamRoute
  ProDashboardTeamChatRoute: typeof ProDashboardTeamChatRoute
  ProDashboardIndexRoute: typeof ProDashboardIndexRoute
  ProDashboardMemberMemberIdRoute: typeof ProDashboardMemberMemberIdRoute
}

const ProDashboardRouteChildren: ProDashboardRouteChildren = {
  ProDashboardAppointmentsRoute: ProDashboardAppointmentsRoute,
  ProDashboardAuditLogsRoute: ProDashboardAuditLogsRoute,
  ProDashboardBookingQueueRoute: ProDashboardBookingQueueRoute,
  ProDashboardCalendarRoute: ProDashboardCalendarRoute,
  ProDashboardCertificatesRoute: ProDashboardCertificatesRoute,
  ProDashboardInvoicesRoute: ProDashboardInvoicesRoute,
  ProDashboardPatientsRoute: ProDashboardPatientsRoute,
  ProDashboardPaymentsRoute: ProDashboardPaymentsRoute,
  ProDashboardRecurringBookingsRoute: ProDashboardRecurringBookingsRoute,
  ProDashboardReportsRoute: ProDashboardReportsRoute,
  ProDashboardReviewsRoute: ProDashboardReviewsRoute,
  ProDashboardRewardsRoute: ProDashboardRewardsRoute,
  ProDashboardRolesRoute: ProDashboardRolesRoute,
  ProDashboardSecurityRoute: ProDashboardSecurityRoute,
  ProDashboardServicesRoute: ProDashboardServicesRoute,
  ProDashboardSettingsRoute: ProDashboardSettingsRoute,
  ProDashboardSocialsRoute: ProDashboardSocialsRoute,
  ProDashboardStaffScheduleRoute: ProDashboardStaffScheduleRoute,
  ProDashboardTeamRoute: ProDashboardTeamRoute,
  ProDashboardTeamChatRoute: ProDashboardTeamChatRoute,
  ProDashboardIndexRoute: ProDashboardIndexRoute,
  ProDashboardMemberMemberIdRoute: ProDashboardMemberMemberIdRoute,
}

const ProDashboardRouteWithChildren = ProDashboardRoute._addFileChildren(
  ProDashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  FarmsoDashboardRoute: FarmsoDashboardRouteWithChildren,
  FarmsoLoginRoute: FarmsoLoginRoute,
  PetsoDashboardRoute: PetsoDashboardRouteWithChildren,
  PetsoLoginRoute: PetsoLoginRoute,
  ProAcceptInviteRoute: ProAcceptInviteRoute,
  ProDashboardRoute: ProDashboardRouteWithChildren,
  ProLoginRoute: ProLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
